import { render, staticRenderFns } from "./pda-report.vue?vue&type=template&id=7dff10ec"
import script from "./pda-report.vue?vue&type=script&lang=ts"
export * from "./pda-report.vue?vue&type=script&lang=ts"
import style0 from "../common/report.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports